import { TopNav } from '../components/TopNav'
import { HeroSection } from '../components/HeroSection'
import { SituationalWorkoutsSection } from '../components/SituationalWorkoutsSection'
import { ManualBuilderSection } from '../components/ManualBuilderSection'
import { ActiveSessionSection } from '../components/ActiveSessionSection'
import { ConsistencySection } from '../components/ConsistencySection'
import { Footer } from '../components/Footer'

export default function HomePage() {
  return (
    <div className="bg-surface text-on-surface font-body min-h-screen overflow-x-hidden">
      <TopNav />
      <main className="relative overflow-x-hidden">
        <HeroSection />
        <section id="situational">
          <SituationalWorkoutsSection />
        </section>
        <section id="manual-builder">
          <ManualBuilderSection />
        </section>
        <section id="active-session">
          <ActiveSessionSection />
        </section>
        <ConsistencySection />
      </main>
      <Footer />
    </div>
  )
}
